export enum CarTripModalType {
  None = 'none',
  MissedChangePaxes = 'missedChangePaxes',
}
